import { useAuth0 } from '@auth0/auth0-react';
import { persistor } from '../redux/store';
import Cookies from 'js-cookie';
import { getUserDetails } from '../utils/orgName';
import { ATTR_AUTHORED_KEY, ATTR_CONFIRMED_KEY } from '../pages/new-designs/components/useMemberAttributesPrompt';
import { markLoggingOut } from '../utils/logoutInProgress';

const useLogout = () => {
  const { logout } = useAuth0();
  function clearAllCookies() {
    const cookies = Object.keys(Cookies.get()); // Get all cookie names

    cookies.forEach((cookieName) => {
      Cookies.remove(cookieName, { path: '' });
    });
  }

  const doLogout = async () => {
    // Before anything is cleared: until the browser reaches Auth0, nothing may redirect it elsewhere.
    markLoggingOut();
    const name = localStorage.getItem('orgName') || '';
    const orgName = getUserDetails()?.orgName || name;
    const queryCallback = orgName ? `/#/login?org=${orgName}&prompt=true` : '/#/login?prompt=true';
    localStorage.clear();
    localStorage.removeItem('persist:root');
    // The "I just authored the attribute catalog" deferral is per session, and
    // signing out ends the session even when the tab stays open. Clearing it
    // here is what makes the deferred attributes prompt come back on the next
    // sign-in instead of only after the tab is closed.
    try {
      sessionStorage.removeItem(ATTR_AUTHORED_KEY);
      sessionStorage.removeItem(ATTR_CONFIRMED_KEY);
    } catch {
      /* sessionStorage can be unavailable (private mode) */
    }
    persistor.purge();
    clearAllCookies();
    logout({ returnTo: window.location.origin + queryCallback, federated: false });
  };
  return { doLogout };
};
export default useLogout;
